import { HStack, Tag, Text } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import capitalize from 'lodash/capitalize'
import { observer } from 'mobx-react'
import { ELicenseType } from 'constants/report/license'
import { getLicenseTagBackground, getLicenseTagColor } from 'pages/CompanyReportPage/utils'

const OrganizationReportHeader = () => {
  const { organizationStore } = useStores()
  const { organization } = organizationStore

  return (
    <HStack as="span" spacing={2}>
      <Text as="span">{organization?.name}</Text>
      <Tag
        color={getLicenseTagColor(organization?.license ?? ELicenseType.FREE)}
        background={getLicenseTagBackground(organization?.license ?? ELicenseType.FREE)}
      >
        {capitalize(organization?.license ?? ELicenseType.FREE)}
      </Tag>
    </HStack>
  )
}

export default observer(OrganizationReportHeader)
